import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Menu, X, Phone, Mail } from "lucide-react";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: "Главная", href: "/" },
    { name: "Игры", href: "/games" },
    { name: "Команда", href: "/team" },
    { name: "О нас", href: "/about" },
    { name: "Контакты", href: "/contacts" },
  ];

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="fixed top-0 z-50 w-full bg-background/95 backdrop-blur-xl border-b-2 border-primary/30 shadow-lg shadow-primary/20">
      <div className="absolute inset-0 bg-gradient-to-r from-primary/5 via-transparent to-accent/5 pointer-events-none"></div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex justify-between h-16">
          <div className="flex items-center">
            <Link to="/" className="flex items-center gap-2 group">
              <span className="text-xl font-bold font-cyber text-primary group-hover:text-accent transition-colors duration-300">
                &lt;GameDev/&gt;
              </span>
              <div className="w-2 h-2 bg-primary rounded-full animate-pulse"></div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-6">
            {navigation.map((item) => (
              <Link
                key={item.name}
                to={item.href}
                className={`relative px-4 py-2 text-sm font-medium font-mono transition-all duration-300 group ${
                  isActive(item.href)
                    ? "text-primary"
                    : "text-muted-foreground hover:text-foreground"
                }`}
              >
                <span className="relative z-10">{item.name}</span>
                {isActive(item.href) && (
                  <span className="absolute inset-0 bg-primary/10 border border-primary/40 rounded-sm"></span>
                )}
                {!isActive(item.href) && (
                  <span className="absolute inset-0 bg-accent/5 border border-transparent group-hover:border-accent/30 rounded-sm opacity-0 group-hover:opacity-100 transition-all duration-300"></span>
                )}
              </Link>
            ))}
            <div className="flex items-center space-x-2 text-sm text-muted-foreground border-l border-primary/30 pl-6 ml-2">
              <Mail className="w-4 h-4 text-accent" />
              <span className="hover:text-primary transition-colors font-mono cursor-pointer">contact@gamedev.studio</span>
            </div>
          </div>

          {/* Mobile menu button */}
          <div className="md:hidden flex items-center">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsOpen(!isOpen)}
              className="text-muted-foreground"
            >
              {isOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
            </Button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <div className="md:hidden py-4 border-t border-primary/30 bg-card/50 backdrop-blur-lg">
            <div className="flex flex-col space-y-2">
              {navigation.map((item) => (
                <Link
                  key={item.name}
                  to={item.href}
                  onClick={() => setIsOpen(false)}
                  className={`px-4 py-3 text-sm font-medium font-mono transition-all duration-300 rounded-sm mx-2 ${
                    isActive(item.href)
                      ? "text-primary bg-primary/10 border border-primary/40"
                      : "text-muted-foreground hover:text-foreground hover:bg-accent/5 hover:border-accent/30 border border-transparent"
                  }`}
                >
                  <span className="text-accent">&gt; </span>{item.name}
                </Link>
              ))}
              <div className="px-4 py-3 text-sm text-muted-foreground flex items-center space-x-2 mx-2 mt-4 border-t border-primary/20 pt-4">
                <Mail className="w-4 h-4 text-accent" />
                <span className="font-mono">contact@gamedev.studio</span>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;